import { z } from "zod";

import { ModuleType, TextLlm, VoiceLlm } from "Infrastructure/Api/Api";
import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export const moduleFormSchema = z.object({
  name: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  type: z.enum(ModuleType),
  priceCategoryID: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  customPrompt: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  customPromptPlainText: z.string(),
  textLlms: z
    .array(z.enum(TextLlm))
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  voiceLlms: z
    .array(z.enum(VoiceLlm))
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
});

export type ModuleFormData = z.infer<typeof moduleFormSchema>;
